import { http } from '@/shared/http.ts'

export const getXboxRefresh = async (token: string) => {
  return await http.get('/xbox/refresh', {
    token,
  })
}

type ConnectUrlResponse = { connect_url: string }

export const getXboxConnect = async (token: string): Promise<ConnectUrlResponse> => {
  return await http.get<ConnectUrlResponse>('/xbox/connect', {
    token,
  })
}
